export default "__VITE_ASSET__ajaaoc6F__"